import { Bell, X, Settings } from "lucide-react";

export default function AlertDropdown({
  isOpen, onToggle, onClose, onSettingsOpen,
  signalAlerts, unreadCount, onMarkRead, onDismiss, onTakeTrade
}) {
  return (
    <div className="relative">
      <button
        data-testid="alert-bell-btn"
        onClick={() => { onToggle(); if (!isOpen) onMarkRead(); }}
        className="relative p-1.5 sm:p-2 rounded-lg hover:bg-white/5 transition-colors"
      >
        <Bell className={`w-4 h-4 sm:w-5 sm:h-5 ${unreadCount > 0 ? 'text-[#F59E0B]' : 'text-gray-400'}`} />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 w-4 h-4 sm:w-5 sm:h-5 bg-[#FF3B30] rounded-full flex items-center justify-center text-[9px] sm:text-[10px] font-bold text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {isOpen && (
        <div
          data-testid="alerts-panel"
          className="fixed left-3 right-3 top-16 w-auto sm:absolute sm:left-auto sm:right-0 sm:top-full sm:mt-2 sm:w-[380px] max-h-[70vh] rounded-xl shadow-2xl z-50 overflow-hidden glass-solid"
        >
          <div className="flex items-center justify-between p-3 border-b border-white/5">
            <h4 className="text-sm font-bold text-white">Signal Alerts</h4>
            <div className="flex items-center gap-2">
              <button
                data-testid="alert-settings-btn"
                onClick={onSettingsOpen}
                className="p-1 rounded hover:bg-white/10"
              >
                <Settings className="w-3.5 h-3.5 text-gray-400" />
              </button>
              <button onClick={onClose} className="p-1 rounded hover:bg-white/10">
                <X className="w-3.5 h-3.5 text-gray-400" />
              </button>
            </div>
          </div>
          <div className="overflow-y-auto max-h-[55vh]">
            {signalAlerts.length === 0 ? (
              <div className="p-6 text-center text-gray-500 text-sm">
                <Bell className="w-8 h-8 mx-auto mb-2 text-gray-600" />
                No alerts yet. Signals are checked every 10 seconds.
              </div>
            ) : (
              signalAlerts.map(alert => (
                <div key={alert.id} className={`p-3 border-b border-white/5 hover:bg-white/5 transition-colors ${!alert.read ? 'bg-white/[0.02]' : ''}`}>
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${
                          alert.alert_type === 'STRONG_BUY' ? 'bg-[#00FFA3]/20 text-[#00FFA3]' :
                          alert.alert_type === 'STRONG_SELL' || alert.alert_type === 'HOLDINGS_CONFLICT' || alert.alert_type === 'HOLDINGS_EXIT_RISK' ? 'bg-[#FF3B30]/20 text-[#FF3B30]' :
                          alert.alert_type === 'HOLDINGS_STRONG_BUY' ? 'bg-[#00FFA3]/20 text-[#00FFA3]' :
                          alert.alert_type === 'HOLDINGS_TAKE_PROFIT' ? 'bg-[#FFB020]/20 text-[#FFB020]' :
                          'bg-[#00E0FF]/20 text-[#00E0FF]'
                        }`}>{alert.alert_type.replace('_', ' ')}</span>
                        <span className="text-sm font-bold text-white mono">{alert.symbol}</span>
                        {!alert.read && <span className="w-1.5 h-1.5 rounded-full bg-[#00E0FF]" />}
                      </div>
                      <div className="flex items-center gap-3 text-xs text-gray-400 mb-1">
                        <span>Entry: <span className="text-[#00E0FF] mono">${alert.entry_price}</span></span>
                        <span>Target: <span className="text-[#00FFA3] mono">${alert.target_price}</span></span>
                        <span>Win: <span className="text-white mono">{alert.win_probability}%</span></span>
                      </div>
                      <p className="text-[10px] text-gray-500 truncate">{alert.reasoning}</p>
                      <div className="flex items-center justify-between mt-1">
                        <p className="text-[10px] text-gray-600">{new Date(alert.created_at).toLocaleTimeString()}</p>
                        <button
                          data-testid={`alert-take-trade-${alert.symbol}`}
                          onClick={(e) => { e.stopPropagation(); onTakeTrade(alert); }}
                          className="text-[9px] px-2 py-0.5 rounded bg-[#00FFA3]/10 text-[#00FFA3] hover:bg-[#00FFA3]/20 border border-[#00FFA3]/20"
                        >
                          Take Trade
                        </button>
                      </div>
                    </div>
                    <button onClick={() => onDismiss(alert.id)} className="p-1 rounded hover:bg-white/10 shrink-0">
                      <X className="w-3 h-3 text-gray-500" />
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
